function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M28.6 8.6c-.2-.1-.4-.2-.6-.2H9c-.5 0-.9.4-1 .9L6.4 20.6c0 .2.1.5.2.6.2.2.4.3.7.3h19c.5 0 .9-.4 1-.9L29 9.4c0-.4-.1-.6-.4-.8zm-10.2 5.7c-.1.1-.2.1-.4 0L9.5 9h18.1l-9.2 5.3zM8.7 9.4v-.2l6 3.8L7 20.6 8.7 9.4zM7.3 21l8-7.8 2.5 1.5c.1.1.3.1.5.1s.3 0 .5-.1l2.9-1.7 4.8 7.9H7.3v.1zm19.4-.6l-4.6-7.6 6.3-3.7v.1l-1.7 11.2zM1.3 10.8h5.4c.2 0 .3-.1.3-.3s-.1-.3-.3-.3H1.3c-.2 0-.3.1-.3.3s.1.3.3.3zm4.6 3.6H1.3c-.2 0-.3.1-.3.3s.1.3.3.3h4.6c.2 0 .3-.1.3-.3s-.1-.3-.3-.3zm-.6 4.2h-4c-.2 0-.3.1-.3.3 0 .2.1.3.3.3h4c.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3z"
})));